import { useSyncExternalStore } from 'react';

/* What the report says about itself, published by the grid that counts it. */
export type ReportHealth = {
  critical: number;
  warning: number;
  startFixing: () => void;
};

let health: ReportHealth | null = null;
const listeners = new Set<() => void>();

const emit = () => listeners.forEach(l => l());

export const publishReportHealth = (next: ReportHealth | null) => {
  if (health === next) return;
  if (health && next && health.critical === next.critical && health.warning === next.warning)
    return;
  health = next;
  emit();
};

const subscribe = (l: () => void) => {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
};

export const useReportHealth = () =>
  useSyncExternalStore(
    subscribe,
    () => health,
    () => health
  );
